<template>
  <!-- 提示消息 -->
  <div id="toast" class="toast" :class="{ show: visible }">
    {{ message }}
  </div>
</template>

<script>
/**
 * 提示消息组件
 * @description 用于显示临时提示消息的组件
 */
export default {
  name: 'ToastMessage',
  props: {
    /**
     * 是否显示提示消息
     * @type {boolean}
     */
    visible: {
      type: Boolean,
      default: false
    },
    /**
     * 提示消息内容
     * @type {string}
     */
    message: {
      type: String,
      default: ''
    }
  }
};
</script>
